export default __webpack_public_path__ + "static/media/step-1-of-7.bc594348.svg";